// Generated by purs version 0.14.5
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var plusArray = {
    empty: [  ],
    Alt0: function () {
        return Control_Alt.altArray;
    }
};
var empty = function (dict) {
    return dict.empty;
};
module.exports = {
    empty: empty,
    plusArray: plusArray,
    alt: Control_Alt.alt,
    map: Data_Functor.map,
    "void": Data_Functor["void"]
};
